// *NB: Essentially the same as the sidebar (we use it to show where the Log Action is from)
export const Feature = {
  ADMIN: "ADMIN",
  PROJECT_ADMIN: "PROJECT_ADMIN",
  BROWSE: "BROWSE",
  DASHBOARD: "DASHBOARD",
  STOCK_MANAGEMENT: "STOCK_MANAGEMENT",

  REPORTS: "REPORTS",
  LOGS: "LOGS"
} as const;
